
import {mapState} from 'vuex';
import magazine from '~/graphql/queries/magazine';

export default {
  auth: false,
  apollo: {
    magazine: {
      query: magazine,
      variables() {
        return {
          slug: this.$route.params.slug,
        };
      },
    },
  },
  computed: {
    ...mapState(['page']),
    magazineId() {
      return `magazine-${this.magazine?.id}`;
    },
  },
  mounted() {
    // Dirty fix for Publitas issue, should be discussed with Publitas
    if (localStorage.getItem('reloaded')) {
      localStorage.removeItem('reloaded');
    } else {
      localStorage.setItem('reloaded', '1');
      location.reload();
    }
  },
  head() {
    return {
      ...(this.magazine?.id && {
        script: [
          {
            'data-cfasync': 'false',
            'data-height': 'undefined',
            'data-publication': this.magazine.publitas_url,
            'data-publication-aspect-ratio': '1.4143007360672977',
            'data-responsive': 'true',
            'data-width': 'undefined',
            'data-wrapperId': `publitas-embed-${this.magazineId}`,
            'publitas-embed': '',
            src: 'https://view.publitas.com/embed.js',
            type: 'text/javascript',
            hid: this.magazineId,
          },
        ],
      }),
      title: this.page.title,
    };
  },
};
